export default __webpack_public_path__ + "static/media/g7.cf5bfa11.jpg";